import { useCallback, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'
import { PATHS } from 'routes'
import { useBotData } from 'use-towns-client'
import { type Address } from 'viem'

import { InstallBotBottomBar } from './InstallBotBottomBar'
import { InstallBotLayout } from './InstallBotLayout'

export const InstallBotPage = ({
    isPreview = false,
    onClosePreview,
    appAddress: appAddressProp,
}: {
    isPreview?: boolean
    onClosePreview?: () => void
    appAddress?: Address
}) => {
    const { appAddress: appAddressParam } = useParams<{ appAddress: Address }>()
    const appAddress = appAddressProp ?? appAddressParam
    const { data: bot, error } = useBotData(appAddress ?? undefined)

    useEffect(() => {
        if (error) {
            console.error('[InstallBotPage] Bot not found', error)
        }
    }, [error])

    const navigate = useNavigate()

    const onBack = useCallback(() => {
        if (isPreview) {
            onClosePreview?.()
        } else {
            navigate(`/${PATHS.BOTS}`)
        }
    }, [isPreview, onClosePreview, navigate])

    if (!bot) {
        console.error('[InstallBotPage] Bot not found', appAddress)
        return null
    }

    return (
        <InstallBotLayout
            isPreview={isPreview}
            bottomContent={!isPreview && <InstallBotBottomBar bot={bot} />}
            bot={bot}
            onBack={onBack}
        />
    )
}
